<app-global-loading-overlay></app-global-loading-overlay>
<p-toast></p-toast>
<app-upgrade-modal></app-upgrade-modal>
<router-outlet></router-outlet>
